module.exports = "<mat-list class=\"container\">\n  <mat-list-item\n    class=\"item\"\n    *ngFor=\"let tariff of tariffService.tariffsList | async\"\n    (click)=\"select(tariff)\"\n    [class.selected]=\"tariff.id == selectedTariffId\"\n    class=\"flex\"\n  >\n    {{ tariff.name }}\n    <mat-icon class=\"del-icon\" (click)=\"removeItem(tariff)\">delete</mat-icon>\n  </mat-list-item>\n</mat-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-tariffs/tariffs-list/tariffs-list.component.html
// module id = ./src/app/driver-tariffs/tariffs-list/tariffs-list.component.html
// module chunks = main